import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagicWand2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMagicWand2"><Path fillRule="evenodd" clipRule="evenodd" d="M18.0002 2.08582L21.9144 6.00003L6.00015 21.9142L2.08594 18L18.0002 2.08582ZM15.6644 7.25003L16.7502 8.33582L19.0859 6.00003L18.0002 4.91424L15.6644 7.25003Z" fill="currentColor"/><Path d="M10 2L11 0L12 2L14 3L12 4L11 6L10 4L8 3L10 2Z" fill="currentColor"/><Path d="M19 13L20 11L21 13L23 14L21 15L20 17L19 15L17 14L19 13Z" fill="currentColor"/><Path d="M5 7L6 5L7 7L9 8L7 9L6 11L5 9L3 8L5 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMagicWand2;
